import React from 'react';
import {LoginButton} from '@acuwize/shared';

// Login landing. Three providers shown for visual completeness; Microsoft
// and Meta are disabled for v1 (their backend routes return 501 — see
// portal/README.md §16). The Continue-with-Google button hrefs to
// /auth/google which is a full-page navigation, not a fetch.

function Login() {
    return (
        <div className="portal-login">
            <div className="portal-login__card">
                <h1 className="portal-login__title">Sign in to Tenet AI</h1>
                <p className="portal-login__subtitle">
                    Use your Google Workspace account to access your workgroup&rsquo;s OpenAPI specs.
                </p>
                <div className="portal-login__buttons">
                    <LoginButton provider="google" />
                    <LoginButton provider="microsoft" disabled />
                    <LoginButton provider="meta" disabled />
                </div>
                <p className="portal-login__note">
                    Microsoft and Meta sign-in coming soon.
                </p>
            </div>
        </div>
    );
}

export default Login;
